export const PRICING_METHOD_SIMPLE = "Simple" as const;
export const PRICING_METHOD_FULL = "Full" as const;
export const PRICING_METHOD_PRICER_TABLES = "PricerTables" as const;

export const PRICING_METHOD_LABEL_SIMPLE = "Simple";
export const PRICING_METHOD_LABEL_FULL = "Full";
export const PRICING_METHOD_LABEL_PRICER_TABLES = "Pricer Tables";

export const PRICING_METHODS = {
  SIMPLE: PRICING_METHOD_SIMPLE,
  FULL: PRICING_METHOD_FULL,
  PRICER_TABLES: PRICING_METHOD_PRICER_TABLES,
} as const;

export const PRICING_METHOD_LABELS = {
  SIMPLE: PRICING_METHOD_LABEL_SIMPLE,
  FULL: PRICING_METHOD_LABEL_FULL,
  PRICER_TABLES: PRICING_METHOD_LABEL_PRICER_TABLES,
} as const;

export type PricingMethod =
  | typeof PRICING_METHOD_SIMPLE
  | typeof PRICING_METHOD_FULL
  | typeof PRICING_METHOD_PRICER_TABLES;
